import sum from './sum.js';

export default function (array) {
  return sum(array) / array.length
}
